import { UploadCard } from '@/components/upload-card/UploadCard'
import { UploadCardStatus } from '@/components/upload-card/constants'
import { TimelineFileStatus } from '../../constants'

type TimelineFileCardProps = {
  fileName: string
  // The Add Files page only ever shows in-flight upload states; EXTRACTED is reserved for the
  // (read-only) roster elsewhere.
  status: Exclude<TimelineFileStatus, TimelineFileStatus.EXTRACTED>
  errorMessage?: string
  onRemove: () => void
  onClick?: () => void
}

// Only these statuses represent a file the viewer can open, and only PDFs are viewable.
const kClickableStatuses: TimelineFileStatus[] = [TimelineFileStatus.PROCESSING, TimelineFileStatus.COMPLETED]

function uploadCardStatus(status: Exclude<TimelineFileStatus, TimelineFileStatus.EXTRACTED>): UploadCardStatus {
  switch (status) {
    case TimelineFileStatus.UPLOADING:
      return UploadCardStatus.Uploading
    case TimelineFileStatus.PROCESSING:
      return UploadCardStatus.Processing
    case TimelineFileStatus.COMPLETED:
      return UploadCardStatus.Complete
    case TimelineFileStatus.ERROR:
      return UploadCardStatus.Error
  }
}

/**
 * A pending-upload row on the timeline Add Files surface. Thin wrapper over the shared UploadCard
 * that supplies the timeline open rules.
 */
export default function TimelineFileCard(props: TimelineFileCardProps) {
  const { fileName, status, errorMessage, onRemove, onClick } = props
  const isClickable = Boolean(onClick) && kClickableStatuses.includes(status) && fileName.toLowerCase().endsWith('.pdf')
  const isUploading = status === TimelineFileStatus.UPLOADING

  return (
    <UploadCard
      status={uploadCardStatus(status)}
      filename={fileName}
      message={status === TimelineFileStatus.ERROR ? errorMessage || 'Document could not be read' : undefined}
      // The remove action cancels the transfer while it is still running, and dismisses the row after.
      onCancel={isUploading ? onRemove : undefined}
      dismissLabel={`Remove ${fileName}`}
      onDismiss={!isUploading ? onRemove : undefined}
      onRowClick={isClickable ? onClick : undefined}
    />
  )
}
